import img from "../../assets/cars.webp";
import { FaRegCalendarAlt } from "react-icons/fa";
import { IoSpeedometerOutline } from "react-icons/io5";
import { FaAward } from "react-icons/fa";

export default function CarsSection() {
	return (
		<div className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-slate-900">
			<div className="absolute inset-0 w-full h-full">
				<div
					className="w-full h-full bg-cover bg-center bg-fixed"
					style={{ backgroundImage: `url(${img})` }}
					role="img"
				/>
				<div className="absolute inset-0 bg-black/50" />
			</div>
			<div className="relative z-10 container mx-auto px-6 py-12">
				<div className="grid md:grid-cols-3 gap-8 md:gap-12 items-start text-white text-center">
					<div className="flex flex-col items-center justify-start p-6 bg-white/10 rounded-lg shadow-xl backdrop-blur-sm">
						<FaRegCalendarAlt size={50} color="#cbbca3" className="mb-4" />
						<p>Reservación Calendarizada</p>
					</div>
					<div className="flex flex-col items-center justify-start p-6 bg-white/10 rounded-lg shadow-xl backdrop-blur-sm">
						<IoSpeedometerOutline size={50} color="#cbbca3" className="mb-4" />
						<p>Entrega del vehículo con tanque lleno</p>
					</div>
					<div className="flex flex-col items-center justify-start p-6 bg-white/10 rounded-lg shadow-xl backdrop-blur-sm">
						<FaAward size={50} color="#cbbca3" className="mb-4" />
						<p>Manejamos seguro de cobertura amplia</p>
					</div>
				</div>
			</div>
		</div>
	);
}
